import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { VideoUploadComponent } from '../../../common/video-upload/video-upload.component';
import { NotificationComponent } from '../../../common/notification/notification.component';
import { BaseComponent } from '../../../common/BaseComponent';
import { PinComponent } from '../../../common/pin/pin.component';
import { Helper } from '../../../../../utils/helper';
import { MetaVideoVideoInitModel, MetaVideoVideoInitVariables, MetaVideoVideoModel, MetaVideoVideoVariables } from '../../../../../models/meta-template/meta-video-video.interface';

/**
 * The single creative of a Meta video ad. Type, size and dimensions are checked on upload by `VideoUploadComponent`;
 * codec and audio rules are enforced by the backend. That the video is present at all is enforced on save via `requiredFields`.
 */
@Component({
    selector: 'app-meta-video-video',
    imports: [
        CommonModule,
        ReactiveFormsModule,
        VideoUploadComponent,
        NotificationComponent,
        PinComponent,
    ],
    templateUrl: './meta-video-video.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './meta-video-video.component.scss'
})
export class MetaVideoVideoComponent extends BaseComponent implements OnInit {
  //@ input
  @Input() block: MetaVideoVideoModel = new MetaVideoVideoInitModel();
  @Input() isPreview = false;
  //@ output
  @Output() blockData = new EventEmitter<any>(); // Event emitter to send data to the parent
  @Output() removeBlockEvent = new EventEmitter<string | null>(); // New EventEmitter for remove

  ngOnInit() {
    if (Helper.isEmpty(this.block.variables!)) {
      this.block.variables = new MetaVideoVideoInitVariables()
    }
  }

  //@remove
  removeBlock(): void {
    this.removeBlockEvent.emit(this.block.blockId); // Emit the ID to parent
  }

  //@onChange
  onChange(value: any, fieldName: keyof MetaVideoVideoVariables) {
    if (this.block.variables) {
      this.block.variables[fieldName] = value;
      this.blockData.emit(this.block);
    }
  }

  onContainerClick(event: MouseEvent) {
    // Forward the click event to the child app-pin component
    this.pinComponent.onContainerClick(event);
  }
}
